import { Component, Renderer2, AfterViewInit, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorials',
  templateUrl: './tutorials.component.html',
  styleUrls: ['./tutorials.component.css']
})
export class TutorialsComponent implements OnInit {

  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    // Add a class to the body element
    this.renderer.addClass(document.body, 'height-full');
    this.renderer.addClass(document.body, 'bg-black');
  }
  ngOnDestroy() {
    // Remove the class from the body element
    this.renderer.removeClass(document.body, 'height-full');
    this.renderer.removeClass(document.body, 'bg-black');
  }

}
